import React from 'react';
import { motion } from 'framer-motion';

export default function Background() {
  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-0">
      {/* Dynamic shifting background gradient */}
      <motion.div
        animate={{
          background: [
            'radial-gradient(circle at 10% 10%, #15453e 0%, #0E2F2A 60%, #061513 100%)',
            'radial-gradient(circle at 20% 20%, #174d45 0%, #0E2F2A 70%, #061513 100%)',
            'radial-gradient(circle at 10% 10%, #15453e 0%, #0E2F2A 60%, #061513 100%)',
          ]
        }}
        transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
        className="absolute inset-0"
      />

      {/* Soft volumetric light from top-left */}
      <div className="absolute -top-[40%] -left-[30%] w-[150%] h-[150%] bg-[radial-gradient(ellipse_at_center,rgba(244,241,230,0.08)_0%,transparent_50%)] blur-[100px] opacity-100" />
      
      {/* Secondary subtle light to balance */}
      <div className="absolute -bottom-[50%] -right-[30%] w-[100%] h-[100%] bg-[radial-gradient(circle_at_center,rgba(201,162,39,0.03)_0%,transparent_60%)] blur-[80px]" />

      {/* Subtle Japanese Wave Pattern (Seigaiha inspired) */}
      <div 
        className="absolute inset-0 opacity-[0.04] mix-blend-overlay"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23F4F1E6' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundSize: '40px 40px'
        }}
      />
    </div>
  );
}